import { render } from "./MessageMain.vue?vue&type=template&id=791ab73e"
import script from "./MessageMain.vue?vue&type=script&lang=js"
export * from "./MessageMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__